export default __webpack_public_path__ + "images/pictograms/stars.svg?68561e89c4ef9cfc34ffa0d9de53795717cdf8319f1401b52b8c08da54156cc8";